<app-benefit-header id="benefits-app-header" [datorating]="newRating"  ></app-benefit-header>
<app-benefit-body id="benefits-app-body" (newRating)="passValueVote($event)" ></app-benefit-body>
